import { ko } from 'date-fns/locale/ko';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    deleteFilterPAEAA010Conditions,
    fetchInitialConditions,
    saveFilterPAEAA010Conditions,
    saveMatchingConditions,
    updateFilterPAEAA010Conditions,
} from '../../../../redux/reducers/PAEAA010';
import { getPAEAA010search } from '../../../../services/Api';
import Checkbox from '../../../../shared/components/Checkbox';
import Dropdown from '../../../../shared/components/Dropdown';
import Radiobox from '../../../../shared/components/Radiobox';
import Tabs from '../../../../shared/components/Tabs';
import { getCheckBoxValues, getDropdownValue, getRadioBoxValue } from '../../../../utils';
registerLocale('ko', ko);

const PopupPAIAD010 = ({ onClose, decode, indexActive }) => {
    const [totalSelectedConditions, setTotalSelectedConditions] = useState(0);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [recruitLicenses, setRecruitLicenses] = useState([]);
    const [recruitForms, setRecruitForms] = useState([]);
    const [recruitPositions, setRecruitPositions] = useState([]);
    const [recruitPays, setRecruitPays] = useState([]);
    const [recruitDays, setRecruitDays] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState([]);
    const [recruitClass, setRecruitClass] = useState([]);
    const [recruitProvinces, setRecruitProvinces] = useState([]);
    const [recruitCommunes, setRecruitCommunes] = useState({});
    const [selectedProvince, setSelectedProvince] = useState(null);

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [checkedValues, setCheckedValues] = useState({
        RegionGu: [],
    });
    const [checkedLikeRightValues, setCheckedLikeRightValues] = useState({});
    const [applyMethod, setApplyMethod] = useState({});
    const [applyMethodChecked, setApplyMethodChecked] = useState({
        ApplyMethod: [],
    });

    const [conditionSearch, setConditionSearch] = useState('CompanyName');
    const [keywords, setKeywords] = useState([]);

    const savedConditions = useSelector(({ PAEAA010 }) => PAEAA010.savedPAEAA010Conditions || []);
    const dispatch = useDispatch();

    const [popupTabChange, setPopupTabChange] = useState(0);

    useEffect(() => {
        setTotalSelectedConditions(checkedLabels.length);
    }, [checkedLabels]);

    useEffect(() => {
        if (!applyMethod || typeof applyMethod !== 'object') {
            setApplyMethodChecked({ ApplyMethod: [] });
            return;
        }

        const method = Object.values(applyMethod).flat();
        setApplyMethodChecked({
            ApplyMethod: method,
        });
    }, [applyMethod]);

    const handleTabChange = (index) => {
        setConditionSearch('CompanyName');
        setActiveTabIndex(index);
    };

    const handlePopupTabChange = (index) => {
        setPopupTabChange(index);
        const item = savedConditions[index];
        if (!item) {
            setCheckedValues({});
            setCheckedLikeRightValues({});
            setStartDate('');
            setEndDate('');
            setCheckedLabels([]);
            setApplyMethod({});
            setKeywords([]);
            return;
        }

        const {
            checkedStoreValues,
            checkedLikeRightStoreValues,
            startStoreDate,
            endStoreDate,
            checkedStoreLabels,
            applyMethodStore,
        } = item;

        setCheckedValues(checkedStoreValues);
        setCheckedLikeRightValues(checkedLikeRightStoreValues);
        setStartDate(startStoreDate);
        setEndDate(endStoreDate);
        setCheckedLabels(checkedStoreLabels);
        setApplyMethod(applyMethodStore);

        const keywordSet = new Set();
        if (
            checkedLikeRightStoreValues &&
            !checkedLikeRightStoreValues['RecruitClass'] &&
            !checkedLikeRightStoreValues['RecruitPosition']
        ) {
            Object.values(checkedLikeRightStoreValues).forEach((keywords) => {
                keywords.forEach((keyword) => keywordSet.add(keyword));
            });
        }
        setKeywords([...keywordSet]);
    };

    useEffect(() => {
        handlePopupTabChange(indexActive - 1 || 0);
        // eslint-disable-next-line
    }, []);

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'conditionSearch':
                setConditionSearch(selectedValue);
                break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    // select box, radio box
    const handleInputChange = (e) => {
        const { name, value, checked, type, id } = e.target;

        if (totalSelectedConditions >= 5 && checked) {
            alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
            return;
        }

        setCheckedLikeRightValues((prevCheckedLikeRightValues) => {
            let newCheckedLikeRightValues = { ...prevCheckedLikeRightValues };

            if (type === 'checkbox' && name === 'RecruitPosition') {
                newCheckedLikeRightValues = getCheckBoxValues(newCheckedLikeRightValues, name, value, checked);
                const option = getOptions(name)?.find((opt) => opt.value === value);

                if (!option) {
                    return newCheckedLikeRightValues;
                }

                if (checked) {
                    newCheckedLikeRightValues.RecruitPosition = [
                        ...(newCheckedLikeRightValues.RecruitPosition || []),
                        option.checked,
                    ];
                } else {
                    newCheckedLikeRightValues.RecruitPosition = (
                        newCheckedLikeRightValues.RecruitPosition || []
                    ).filter((item) => item !== option.checked);
                }

                newCheckedLikeRightValues.RecruitPosition = (newCheckedLikeRightValues.RecruitPosition || []).filter(
                    (item) => item !== null && item !== undefined,
                );

                if (newCheckedLikeRightValues.RecruitPosition.length === 0) {
                    delete newCheckedLikeRightValues.RecruitPosition;
                }
            }

            return newCheckedLikeRightValues;
        });

        setCheckedValues((checkedValues) => {
            let newCheckedValues = { ...checkedValues };

            if (type === 'checkbox' && name !== 'ApplyMethod' && name !== 'RecruitPosition') {
                // lấy value checkbox
                newCheckedValues = getCheckBoxValues(newCheckedValues, name, value, checked);

                // kiểm tra nếu là RegionGu, cập nhật RegionSi tương ứng
                if (name === 'RegionGu') {
                    const selectedRegionSi = Object.entries(recruitCommunes).find(([key, communes]) =>
                        communes.some((commune) => commune.code === value),
                    );

                    if (selectedRegionSi) {
                        const [regionSiCode] = selectedRegionSi;
                        const currentRegionSi = newCheckedValues.RegionSi || [];
                        const currentRegionGu = newCheckedValues.RegionGu || [];

                        if (checked) {
                            if (value.endsWith('00')) {
                                const regionGuCodes =
                                    recruitCommunes[regionSiCode]?.map((commune) => commune.code) || [];
                                newCheckedValues.RegionGu = currentRegionGu.filter(
                                    (guCode) => !regionGuCodes.includes(guCode),
                                );
                                newCheckedValues.RegionGu.push(value);
                            } else {
                                const regionGuEndingWith00 = currentRegionGu.find((guCode) => guCode.endsWith('00'));
                                if (regionGuEndingWith00) {
                                    newCheckedValues.RegionGu = currentRegionGu.filter(
                                        (guCode) => guCode !== regionGuEndingWith00,
                                    );
                                }

                                if (!newCheckedValues.RegionGu.includes(value)) {
                                    newCheckedValues.RegionGu.push(value);
                                }
                            }

                            if (!currentRegionSi.includes(regionSiCode)) {
                                newCheckedValues.RegionSi = [...currentRegionSi, regionSiCode];
                            }
                        } else {
                            newCheckedValues.RegionGu = currentRegionGu.filter((guCode) => guCode !== value);

                            const remainingRegionGu = newCheckedValues.RegionGu || [];
                            const isRegionSiStillRelevant = recruitCommunes[regionSiCode]?.some((commune) =>
                                remainingRegionGu.includes(commune.code),
                            );

                            if (!isRegionSiStillRelevant) {
                                newCheckedValues.RegionSi = currentRegionSi.filter((code) => code !== regionSiCode);
                                if (newCheckedValues.RegionSi.length === 0) {
                                    delete newCheckedValues.RegionSi;
                                }
                            }
                        }
                    }
                }
            } else if (type === 'radio') {
                // lấy value radio
                // trường hợp đặc biệt cho `recruitCareer`
                if (name === 'RecruitCareer' && value !== '경력') {
                    // nếu không phải '경력': reset expMin và expMax
                    delete newCheckedValues.ExpMin;
                    delete newCheckedValues.ExpMax;
                }
                newCheckedValues = getRadioBoxValue(newCheckedValues, name, value, checked);
            }

            return newCheckedValues;
        });

        setApplyMethod((prevApplyMethod) => {
            let newApplyMethod = { ...prevApplyMethod };

            if (type === 'checkbox' && name === 'ApplyMethod') {
                const methodId = id;

                if (checked) {
                    if (!newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = [];
                    }

                    if (!newApplyMethod[methodId].includes(value)) {
                        newApplyMethod[methodId].push(value);
                    }
                } else {
                    if (newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = newApplyMethod[methodId].filter((item) => item !== value);

                        // Nếu không còn value nào, xóa key methodId
                        if (newApplyMethod[methodId].length === 0) {
                            delete newApplyMethod[methodId];
                        }
                    }
                }
            }

            return newApplyMethod;
        });
    };

    const getOptions = (name) => {
        const options = {
            RecruitLicense: recruitLicenses.map((license) => ({
                id: 'recruitLicenses_' + license.code,
                label: license.codeName,
                value: license.code,
            })),

            RecruitForm: recruitForms.map((form) => ({
                id: 'recruitForms_' + form.code,
                label: form.codeName,
                value: form.code,
            })),

            RecruitPosition: recruitPositions.map((position) => ({
                id: 'recruitPositions_' + position.code,
                label: position.codeName,
                value: position.codeName,
            })),

            RecruitPay: recruitPays.map((pay) => ({
                id: 'recruitPays_' + pay.code,
                label: pay.codeName,
                value: pay.code,
            })),

            RecruitCareer: [
                { id: 'recruitCareers_999', value: '무관', label: '무관' },
                { id: 'recruitCareers_001', value: '신입', label: '신입' },
                { id: 'recruitCareers_009', value: '경력', label: '경력' },
            ],

            Assist1: [
                { id: 'assist1_101', value: '101', label: '기숙사지원' },
                { id: 'assist1_102', value: '102', label: '식대지원' },
            ],

            Assist2: [{ id: 'assist2_201', value: '201', label: '경조사지원' }],

            Assist3: [
                { id: 'assist3_301', value: '301', label: '자기계발비지원' },
                { id: 'assist3_302', value: '302', label: '연월차지원' },
                { id: 'assist3_303', value: '303', label: '휴가비지원' },
            ],
            Assist4: [{ id: 'assist4_401', value: '401', label: '4대보험지원' }],

            Assist5: [
                { id: 'assist5_501', value: '501', label: '연봉제' },
                { id: 'assist5_502', value: '502', label: '인센티브제' },
                { id: 'assist5_503', value: '503', label: '퇴직금지원' },
                { id: 'assist5_504', value: '504', label: '야근수당지원' },
                { id: 'assist5_505', value: '505', label: '기타' },
            ],

            RecruitDay: recruitDays.map((day) => ({
                id: 'recruitDays_' + day.code,
                label: day.codeName,
                value: day.code,
            })),

            ApplyMethod: [
                { id: 'ApplyMethod1', label: '온라인 즉시지원', value: '001' },
                { id: 'ApplyMethod2', label: '전화접수', value: '002' },
                { id: 'ApplyMethod3', label: '이메일접수', value: '003' },
                { id: 'ApplyMethod4', label: 'FAX접수', value: '004' },
                { id: 'ApplyMethod5', label: '우편접수', value: '005' },
            ],

            RecruiteCareerYear: [
                { value: '1', option: '1년' },
                { value: '2', option: '2년' },
                { value: '3', option: '3년' },
                { value: '4', option: '4년' },
                { value: '5', option: '5년' },
                { value: '6', option: '6년' },
                { value: '7', option: '7년' },
                { value: '8', option: '8년' },
                { value: '9', option: '9년' },
                { value: '10', option: '10년' },
                { value: '11', option: '11년' },
                { value: '12', option: '12년' },
                { value: '13', option: '13년' },
                { value: '14', option: '14년' },
                { value: '15', option: '15년' },
                { value: '16', option: '16년' },
                { value: '17', option: '17년' },
                { value: '18', option: '18년' },
                { value: '19', option: '19년' },
                { value: '20', option: '20년' },
                { value: '21', option: '21년' },
                { value: '22', option: '22년' },
                { value: '23', option: '23년' },
                { value: '24', option: '24년' },
                { value: '25', option: '25년' },
                { value: '26', option: '26년' },
                { value: '27', option: '27년' },
                { value: '28', option: '28년' },
                { value: '29', option: '29년' },
                { value: '30', option: '30년' },
            ],
        };
        return options[name];
    };

    const handleRemoveLabel = (label) => {
        // xử lý xóa StartDate và EndDate
        if (label.startsWith('채용기간:')) {
            setStartDate('');
            setEndDate('');
        }

        setCheckedValues((prevValues) => {
            const newValues = { ...prevValues };

            const [regionSiName, regionGuName] = label.split(' > ');

            // duyệt qua các key trong checkedValues
            Object.entries(newValues).forEach(([key, values]) => {
                const options = getOptions(key);

                // xử lý xóa RecruitCareer với giá trị '경력'
                if (key === 'RecruitCareer' && label.startsWith('경력:')) {
                    // xóa expMin và expMax khi label là dạng 경력: X ~ Y
                    delete newValues.ExpMin;
                    delete newValues.ExpMax;
                    delete newValues[key];
                    return;
                }

                // xử lý RegionGu
                if (key === 'RegionGu') {
                    // tìm RegionSi liên kết với RegionGu từ recruitCommunes
                    const matchedCommune = Object.entries(recruitCommunes).find(([regionSiCode, communes]) => {
                        const regionSi = recruitProvinces.find((province) => province.code === regionSiCode);
                        return (
                            regionSi &&
                            regionSi.codeName === regionSiName &&
                            communes.some((commune) => commune.codeName === regionGuName)
                        );
                    });

                    if (matchedCommune) {
                        const [regionSiCode, communes] = matchedCommune;

                        // loại bỏ RegionGu được chọn khỏi checkedValues
                        const communeToRemove = communes.find((commune) => commune.codeName === regionGuName);
                        if (communeToRemove) {
                            newValues.RegionGu = newValues.RegionGu.filter((code) => code !== communeToRemove.code);
                            // nếu RegionGu trống, xóa luôn key RegionGu
                            if (newValues.RegionGu.length === 0) {
                                delete newValues.RegionGu;
                            }

                            // kiểm tra nếu RegionSi còn liên kết với các RegionGu khác
                            const remainingRegionGu = newValues.RegionGu || [];
                            const isRegionSiStillRelevant = communes.some((commune) =>
                                remainingRegionGu.includes(commune.code),
                            );

                            if (!isRegionSiStillRelevant) {
                                // loại bỏ RegionSi nếu không còn liên kết
                                newValues.RegionSi = (newValues.RegionSi || []).filter((code) => code !== regionSiCode);

                                if (newValues.RegionSi.length === 0) {
                                    delete newValues.RegionSi;
                                }
                            }
                        }
                    }
                }

                // xử lý các giá trị khác
                if (!options) return;

                // tìm value tương ứng với label
                const matchedOption = options.find((option) => option.label === label);
                if (matchedOption) {
                    if (Array.isArray(values)) {
                        // nếu là mảng (checkbox), loại bỏ giá trị tương ứng
                        newValues[key] = values.filter((value) => value !== matchedOption.value);
                        if (newValues[key].length === 0) {
                            delete newValues[key];
                        }
                    } else if (values === matchedOption.value) {
                        // nếu là giá trị đơn (radio, select), đặt lại giá trị
                        delete newValues[key];
                    }
                }
            });
            return newValues;
        });

        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            // xóa dữ liệu trong checkedLikeRightValues
            checkedLikeRightValues &&
                Object.entries(prevValues).forEach(([key, values]) => {
                    if (key === 'RecruitClass') {
                        values.forEach((code, index) => {
                            const recruit = recruitClass.find((item) => item.code === code && item.codeName === label);
                            if (recruit) {
                                newValues['RecruitClass'] = [...values.slice(0, index), ...values.slice(index + 1)];
                            }
                        });
                        if (newValues['RecruitClass'].length === 0) {
                            delete newValues['RecruitClass'];
                        }
                    } else if (key === 'RecruitPosition') {
                        values.forEach((code, index) => {
                            newValues['RecruitPosition'] = [...values.slice(0, index), ...values.slice(index + 1)];
                        });

                        if (newValues['RecruitPosition'].length === 0) {
                            delete newValues['RecruitPosition'];
                        }
                    }
                });

            return newValues;
        });

        setApplyMethod((prevValues) => {
            const newValues = { ...prevValues };
            const options = getOptions('ApplyMethod');

            Object.entries(newValues).forEach(([key, values]) => {
                const valueArray = Array.isArray(values) ? values : [values];

                const matchedOption = options.find((option) => valueArray.includes(option.value));

                if (matchedOption && matchedOption.label === label) {
                    delete newValues[key];
                }
            });

            return newValues;
        });

        // xóa khỏi keywords và các trường 'CompanyName', 'Title', 'FTS_Contents'
        const isKeywordLabel = label && keywords.includes(label); // kiểm tra có trong keywords list không

        if (isKeywordLabel) {
            // xóa keyword khỏi `keywords` state
            const keywordToRemove = label;

            setKeywords((prevKeywords) => {
                return prevKeywords.filter((keyword) => keyword !== keywordToRemove);
            });

            // xóa keyword khỏi `CompanyName`, `Title`, `FTS_Contents` trong checkedLikeRightValues
            setCheckedLikeRightValues((prevValues) => {
                const newValues = { ...prevValues };

                ['CompanyName', 'Title', 'FTS_Contents'].forEach((field) => {
                    if (newValues[field]) {
                        // loại bỏ keyword khỏi các trường này
                        newValues[field] = newValues[field].filter((value) => value !== keywordToRemove);

                        // nếu trường trống sau khi xóa keyword, xóa luôn key đó
                        if (newValues[field].length === 0) {
                            delete newValues[field];
                        }
                    }
                });

                return newValues;
            });
        }

        // xóa label khỏi danh sách `checkedLabels`
        setCheckedLabels((prevLabels) => prevLabels.filter((l) => l !== label));
    };

    const handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (totalSelectedConditions >= 5) {
                alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
                return;
            }

            const inputValue = e.target.value.trim();
            const inputName = e.target.name;

            if (inputValue) {
                setCheckedLikeRightValues((prevValues) => {
                    const newValues = { ...prevValues };

                    if (inputName === 'searchAll') {
                        // thêm inputValue vào 'CompanyName', 'Title', và 'FTS_Contents'
                        ['CompanyName', 'Title', 'FTS_Contents'].forEach((key) => {
                            if (!newValues[key]) {
                                newValues[key] = [];
                            }

                            // thêm giá trị vào khóa tương ứng nếu nó chưa có ở đó
                            if (!newValues[key].includes(inputValue)) {
                                newValues[key].push(inputValue);
                            }
                        });
                    } else {
                        if (!newValues[conditionSearch]) {
                            newValues[conditionSearch] = [];
                        }
                        const updatedKeywords = [...newValues[conditionSearch], inputValue];
                        newValues[conditionSearch] = [...new Set(updatedKeywords)];
                    }

                    return newValues;
                });

                setKeywords((prevKeywords) => {
                    const updatedKeywords = [...prevKeywords, inputValue];
                    return [...new Set(updatedKeywords)];
                });

                e.target.value = '';
            }
        }
    };

    // datetime input
    const handleDateChange = (date, name) => {
        if (totalSelectedConditions >= 5) {
            alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
            return;
        }
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };

    // tab 1
    useEffect(() => {
        if (recruitProvinces.length > 0) {
            setSelectedProvince(recruitProvinces[0].code);
        }
    }, [recruitProvinces]);

    const handleProvinceClick = (code) => {
        setSelectedProvince(code);
    };

    const communesToRender = recruitCommunes[selectedProvince] || [];

    // tab 2
    const handleCheckRecruitClass = (code) => {
        const isAlreadySelected = (checkedLikeRightValues['RecruitClass'] || []).includes(code);

        if (totalSelectedConditions >= 5 && !isAlreadySelected) {
            alert('추천 인재 조건은 최대 5개까지 등록 가능합니다.');
            return;
        }

        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            const recruitClass = newValues['RecruitClass'] || [];

            if (recruitClass.includes(code)) {
                newValues['RecruitClass'] = recruitClass.filter((item) => item !== code);
            } else {
                newValues['RecruitClass'] = [...recruitClass, code];
            }

            if (newValues['RecruitClass'].length === 0) {
                delete newValues['RecruitClass'];
            }

            return newValues;
        });
    };

    // get label
    const getCheckedLabels = () => {
        const labels = [];
        const startDateChecked =
            startDate !== undefined && moment(startDate).isValid() ? moment(startDate).format('yyyy-MM-DD') : '';
        const endDateChecked =
            endDate !== undefined && moment(endDate).isValid() ? moment(endDate).format('yyyy-MM-DD') : '';

        // lấy label từ checkedLikeRightValues
        if (checkedLikeRightValues && typeof checkedLikeRightValues === 'object') {
            Object.entries(checkedLikeRightValues).forEach(([key, values]) => {
                if (key === 'RecruitClass') {
                    const valueArray = Array.isArray(values) ? values : [values];
                    valueArray.forEach((code) => {
                        const recruit = recruitClass?.find((item) => item.code === code);

                        if (recruit) {
                            labels.push(recruit.codeName);
                        }
                    });
                }

                if (key === 'RecruitPosition') {
                    const valueArray = Array.isArray(values)
                        ? values
                            .map((name) => {
                                const recruit = recruitPositions.find((item) => item.codeName === name);
                                return recruit ? recruit.code : null;
                            })
                            .filter((code) => code !== null)
                        : [values];

                    valueArray.forEach((code) => {
                        const recruit = recruitPositions.find((item) => item.code === code);
                        if (recruit) {
                            labels.push(recruit.codeName);
                        }
                    });
                }
            });
        }

        if (checkedValues && typeof checkedValues === 'object') {
            // lấy label từ checkedValues
            Object.entries(checkedValues).forEach(([key, values]) => {
                if (key === 'RegionGu') {
                    const valueArray = Array.isArray(values) ? values : [values];

                    valueArray.forEach((value) => {
                        // tìm RegionSi chứa RegionGu này
                        const regionSiEntry = Object.entries(recruitCommunes)?.find(([regionSiCode, communes]) =>
                            communes.some((commune) => commune.code === value),
                        );

                        if (regionSiEntry) {
                            const [regionSiCode] = regionSiEntry;

                            // tìm tên RegionSi từ recruitProvinces
                            const regionSi = recruitProvinces.find((province) => province.code === regionSiCode);

                            // tìm thông tin RegionGu
                            const commune = recruitCommunes[regionSiCode]?.find((commune) => commune.code === value);

                            if (regionSi && commune) {
                                labels.push(`${regionSi.codeName} > ${commune.codeName}`);
                            }
                        }
                    });
                }
                const options = getOptions(key);
                const expMin = checkedValues.ExpMin !== undefined ? checkedValues.ExpMin + '년' : '';
                const expMax = checkedValues.ExpMax !== undefined ? checkedValues.ExpMax + '년' : '';

                if (!options) return;

                const valueArray = Array.isArray(values) ? values : [values];
                valueArray.forEach((value) => {
                    const matchedOption = options?.find((option) => option.value === value);
                    if (matchedOption) {
                        if (key === 'RecruitCareer' && value === '경력') {
                            labels.push(`경력: ${expMin} ~ ${expMax}`);
                        } else {
                            labels.push(matchedOption.option || matchedOption.label); // Dùng option nếu có
                        }
                    }
                });
            });
        }

        // lấy label từ applyMethod
        const flatApplyMethodValues =
            applyMethod && typeof applyMethod === 'object' ? Object.values(applyMethod).flat() : [];
        flatApplyMethodValues.forEach((value) => {
            const options = getOptions('ApplyMethod');

            const matchedOption = options.find((option) => option.value === value);

            if (matchedOption) {
                labels.push(matchedOption.label);
            }
        });

        if (keywords && keywords.length > 0) {
            keywords.forEach((keyword) => {
                labels.push(keyword);
            });
        }

        if (startDate || endDate) {
            labels.push(`채용기간: ${startDateChecked} ~ ${endDateChecked}`);
        }
        return labels;
    };

    useEffect(() => {
        getPAEAA010search()
            .then(({ data }) => {
                setRecruitProvinces(data.recruitProvinces);
                setRecruitCommunes(data.recruitCommunes);
                setRecruitLicenses(data.recruitLicense);
                setRecruitForms(data.recruitForm);
                setRecruitPositions(data.recruitPosition);
                setRecruitPays(data.recruitPay);
                setRecruitClass(data.recruitClass);
                setRecruitDays(data.recruitDay);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        setCheckedLabels(getCheckedLabels);
        // eslint-disable-next-line
    }, [checkedValues, checkedLikeRightValues, recruitClass, startDate, endDate]);

    useEffect(() => {
        dispatch(fetchInitialConditions());
    }, [dispatch]);

    const handleUpdateCondition = (index) => {
        const savedDate = moment().format('YYYY/MM/DD');
        const startDateFormat = startDate ? moment(startDate).format('YYYY/MM/DD') : '';
        const endDateFormat = endDate ? moment(endDate).format('YYYY/MM/DD') : '';

        const totalConditions = savedConditions.length;

        if (index > totalConditions) {
            window.alert(`추천 인재 조건을 탭 순서로 저장하셔야 됩니다.`);
            return;
        }
        if (window.confirm('추천 인재 조건을 설정하시겠습니까?')) {
            if (
                checkedLikeRightValues &&
                Object.keys(checkedLikeRightValues).length === 0 &&
                Object.keys(checkedValues).length === 0 &&
                Object.keys(applyMethod).length === 0 &&
                startDateFormat === '' &&
                endDateFormat === '' &&
                checkedLabels.length === 0
            ) {
                dispatch(deleteFilterPAEAA010Conditions(index));
                dispatch(saveMatchingConditions(decode.seq));
                return;
            }

            if (totalConditions === 0 || index === totalConditions) {
                dispatch(
                    saveFilterPAEAA010Conditions({
                        checkedLikeRightValues,
                        checkedValues,
                        applyMethod,
                        startDate: startDate ? moment(startDate).format('YYYY/MM/DD') : '',
                        endDate: endDate ? moment(endDate).format('YYYY/MM/DD') : '',
                        savedDate,
                        checkedLabels,
                    }),
                );
                dispatch(saveMatchingConditions(decode.seq));
            }

            if (index < totalConditions) {
                dispatch(
                    updateFilterPAEAA010Conditions({
                        index,
                        updatedCondition: {
                            checkedLikeRightStoreValues: checkedLikeRightValues,
                            checkedStoreValues: checkedValues,
                            applyMethodStore: applyMethod,
                            startStoreDate: startDateFormat,
                            endStoreDate: endDateFormat,
                            savedStoreDate: savedDate,
                            checkedStoreLabels: checkedLabels,
                        },
                    }),
                );
                dispatch(saveMatchingConditions(decode.seq));
            }
            alert('추천 인재 조건이 설정되었습니다.');
            onClose();
        } else {
            return;
        }
    };

    return (
        <div className="mtch-pop active">
            <div className="mtch-pop__inner">
                <h2 className="mtch-pop__tit">추천 인재 조건</h2>
                <button type="button" id="mtchPopClose" className="rsm-prv__close" onClick={onClose} />
                <div className="mtch-pop__flex">
                    <ul className="mtch-pop__tab">
                        {Array.from({ length: 4 }).map((_, index) => (
                            <li key={'popupTab_' + index}>
                                <button
                                    type="button"
                                    className={`mtch-pop__tab-btn ${popupTabChange === index ? 'active' : ''}`}
                                    onClick={() => handlePopupTabChange(index)}
                                >
                                    스마트매칭 {index + 2}
                                </button>
                            </li>
                        ))}
                    </ul>
                    <div id="tabs-form" className="mtch-pop__section">
                        <div className="mtch-pop__block active">
                            <h3 className="mtch-pop__sbj">매칭조건 {popupTabChange + 2}</h3>
                            <div>
                                <div className="container">
                                    <Tabs
                                        tabs={[
                                            { label: '지역 선택', icon: 'icon-location', isActive: true },
                                            { label: '업무 선택', icon: 'icon-bag', isActive: false },
                                            { label: '상세조건', icon: 'icon-plus', isActive: false },
                                        ]}
                                        blackTab
                                        onTabChange={handleTabChange}
                                    />
                                    <div className="mtch-pop__select">
                                        {activeTabIndex === 0 && (
                                            <div className="mtch-pop__show active">
                                                <div className="tab tabs-select">
                                                    <div className="tabs-flex">
                                                        <div className="tabs-left">
                                                            <ul>
                                                                {recruitProvinces.map((province, index) => (
                                                                    <li
                                                                        className={
                                                                            province.code === selectedProvince
                                                                                ? 'active'
                                                                                : ''
                                                                        }
                                                                        key={index}
                                                                        onClick={() =>
                                                                            handleProvinceClick(province.code)
                                                                        }
                                                                    >
                                                                        <span className="city-name">
                                                                            {province.codeName}
                                                                        </span>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <div className="tabs-right">
                                                            <form>
                                                                {communesToRender.length > 0 && (
                                                                    <>
                                                                        <p className="notification">
                                                                            지역은 최대 <span>5</span>개까지 선택
                                                                            가능합니다.
                                                                        </p>
                                                                        <ul>
                                                                            <Checkbox
                                                                                name="RegionGu"
                                                                                options={communesToRender.map(
                                                                                    (commune) => ({
                                                                                        id: 'regionGu_' + commune.code,
                                                                                        value: commune.code,
                                                                                        label: `${commune.codeName}`,
                                                                                    }),
                                                                                )}
                                                                                onChange={handleInputChange}
                                                                                checked={checkedValues}
                                                                            />
                                                                        </ul>
                                                                    </>
                                                                )}
                                                            </form>
                                                        </div>
                                                    </div>
                                                    <div className="bsns-srch">
                                                        <Dropdown
                                                            placeholder=""
                                                            options={[
                                                                { value: 'CompanyName', option: '치과명' },
                                                                { value: 'Title', option: '제목' },
                                                                { value: 'FTS_Contents', option: '내용' },
                                                            ]}
                                                            name="conditionSearch"
                                                            value={conditionSearch}
                                                            onChange={handleOptionChange}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="검색어 입력하세요"
                                                            onKeyPress={handleInputKeyPress}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {activeTabIndex === 1 && (
                                            <div className="mtch-pop__show active">
                                                <div
                                                    className={`tab tabs-select tabs-select-bag tab-${recruitClass && recruitClass.length % 4 === 0 ? 4 : 5
                                                        }-item`}
                                                >
                                                    <ul>
                                                        {recruitClass.map((recruit) => (
                                                            <li
                                                                key={recruit.code}
                                                                onClick={() => handleCheckRecruitClass(recruit.code)}
                                                                className={
                                                                    checkedLikeRightValues?.['RecruitClass'] &&
                                                                        checkedLikeRightValues['RecruitClass']?.includes(
                                                                            recruit.code,
                                                                        )
                                                                        ? 'active'
                                                                        : ''
                                                                }
                                                            >
                                                                {recruit.codeName}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    <div className="bsns-srch">
                                                        <Dropdown
                                                            placeholder=""
                                                            options={[
                                                                { value: 'CompanyName', option: '치과명' },
                                                                { value: 'Title', option: '제목' },
                                                                { value: 'FTS_Contents', option: '내용' },
                                                            ]}
                                                            name="conditionSearch"
                                                            value={conditionSearch}
                                                            onChange={handleOptionChange}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder="검색어 입력하세요"
                                                            onKeyPress={handleInputKeyPress}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {activeTabIndex === 2 && (
                                            <div className="mtch-pop__show active">
                                                <div className="tab tabs-content tabs-select-plus">
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">자격증</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="RecruitLicense"
                                                                options={getOptions('RecruitLicense')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">근무형태</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="RecruitForm"
                                                                options={getOptions('RecruitForm')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">직급</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="RecruitPosition"
                                                                options={getOptions('RecruitPosition')}
                                                                onChange={handleInputChange}
                                                                checked={checkedLikeRightValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">급여</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="RecruitPay"
                                                                options={getOptions('RecruitPay')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">경력</div>
                                                        <div className="group">
                                                            <Radiobox
                                                                name="RecruitCareer"
                                                                options={getOptions('RecruitCareer')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                            {Array.isArray(checkedValues.RecruitCareer) &&
                                                                checkedValues.RecruitCareer.includes('경력') && (
                                                                    <>
                                                                        (
                                                                        <Dropdown
                                                                            placeholder="경력기간선택"
                                                                            options={getOptions(
                                                                                'RecruiteCareerYear',
                                                                            ).filter(
                                                                                (option) =>
                                                                                    parseInt(option.value, 10) <
                                                                                    parseInt(
                                                                                        checkedValues.expMax || '999',
                                                                                        10,
                                                                                    ),
                                                                            )}
                                                                            name={'ExpMin'}
                                                                            onChange={handleOptionChange}
                                                                        />
                                                                        ~
                                                                        <Dropdown
                                                                            placeholder="경력기간선택"
                                                                            options={getOptions(
                                                                                'RecruiteCareerYear',
                                                                            ).filter(
                                                                                (option) =>
                                                                                    parseInt(option.value, 10) >
                                                                                    parseInt(
                                                                                        checkedValues.expMin || '0',
                                                                                        10,
                                                                                    ),
                                                                            )}
                                                                            name={'ExpMax'}
                                                                            onChange={handleOptionChange}
                                                                        />
                                                                        )
                                                                    </>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="wrap-select-plus-child benefit">
                                                        <div className="title-detailed">복리후생</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="Assist1"
                                                                options={getOptions('Assist1')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                            <Checkbox
                                                                name="Assist2"
                                                                options={getOptions('Assist2')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                            <Checkbox
                                                                name="Assist3"
                                                                options={getOptions('Assist3')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                            <Checkbox
                                                                name="Assist4"
                                                                options={getOptions('Assist4')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                            <Checkbox
                                                                name="Assist5"
                                                                options={getOptions('Assist5')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">근무요일</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="RecruitDay"
                                                                options={getOptions('RecruitDay')}
                                                                onChange={handleInputChange}
                                                                checked={checkedValues}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">접수방법</div>
                                                        <ul className="tab-check-box">
                                                            <Checkbox
                                                                name="ApplyMethod"
                                                                options={getOptions('ApplyMethod')}
                                                                onChange={handleInputChange}
                                                                checked={applyMethodChecked}
                                                            />
                                                        </ul>
                                                    </div>
                                                    <div className="wrap-select-plus-child">
                                                        <div className="title-detailed">채용기간</div>
                                                        <div className="group-datepicker">
                                                            <div className="datepicker-child">
                                                                <DatePicker
                                                                    ref={startDateRef}
                                                                    onChange={(date) =>
                                                                        handleDateChange(date, 'startDate')
                                                                    }
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY/MM/DD'}
                                                                    dateFormat={'yyyy/MM/dd'}
                                                                    selected={startDate}
                                                                    maxDate={endDate || null}
                                                                />
                                                                <i
                                                                    className="icon icon-date"
                                                                    id="start-date-icon"
                                                                    onClick={() => startDateRef.current.setFocus()}
                                                                />
                                                            </div>
                                                            <span>~</span>
                                                            <div className="datepicker-child">
                                                                <DatePicker
                                                                    ref={endDateRef}
                                                                    onChange={(date) =>
                                                                        handleDateChange(date, 'endDate')
                                                                    }
                                                                    locale={'ko'}
                                                                    placeholderText={'YYYY/MM/DD'}
                                                                    dateFormat={'yyyy/MM/dd'}
                                                                    selected={endDate}
                                                                    minDate={startDate || null}
                                                                />
                                                                <i
                                                                    className="icon icon-date"
                                                                    id="end-date-icon"
                                                                    onClick={() => endDateRef.current.setFocus()}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="tab-select-results">
                                        <ul className="results-area">
                                            {Array.isArray(checkedLabels) &&
                                                checkedLabels.length > 0 &&
                                                checkedLabels.map((label, index) => (
                                                    <li key={index}>
                                                        <div className="item-search">{label}</div>
                                                        <span
                                                            className="item-remove icon icon-x"
                                                            onClick={() => handleRemoveLabel(label)}
                                                        ></span>
                                                    </li>
                                                ))}
                                        </ul>
                                        <div className="wrap-option-search-block">
                                            <button onClick={() => handleUpdateCondition(popupTabChange)}>
                                                선택한 조건으로<span>검색하기</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopupPAIAD010;
